module.exports = __webpack_public_path__ + "sd.8518e0d5f041b065322e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sd.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sd.svg
// module chunks = styles